import React from "react";
import { Accordion, Icon } from "semantic-ui-react";

const AccordionContentComponent = ({
  index,
  activeIndex,
  handleClick,
  content,
  contentClassName,
}) => {
  if (!content || !content.component) {
    console.error("Invalid content or missing component:", content);
    return null;
  }

  const ContentComponent = content.component;

  if (typeof ContentComponent !== "function") {
    console.error("Component is not a function:", ContentComponent);
    return <div>Error: Invalid component</div>;
  }

  const isActive = Array.isArray(activeIndex)
    ? activeIndex.includes(index)
    : activeIndex === index;

  return (
    <>
      <Accordion.Title active={isActive} index={index} onClick={handleClick}>
        <Icon name="bars" />
        {content.title}
      </Accordion.Title>
      <Accordion.Content className={contentClassName} active={isActive}>
        <ContentComponent />
      </Accordion.Content>
    </>
  );
};

const AccordionComponent = (props) => {
  const {
    contentClassName,
    contents = [],
    activeIndex = [0, 1],
    setActiveIndex,
  } = props;

  const handleClick = (e, titleProps) => {
    const { index } = titleProps;

    // Check if the clicked index is already in the activeIndex array
    if (Array.isArray(activeIndex)) {
      if (activeIndex.includes(index)) {
        // Remove the index if it's already active
        const newActiveIndex = activeIndex.filter((i) => i !== index);
        setActiveIndex(newActiveIndex);
      } else {
        // Add the index if it's not active
        setActiveIndex([...activeIndex, index]);
      }
    } else {
      // Fallback for single index (exclusive mode)
      const newIndex = activeIndex === index ? -1 : index;
      setActiveIndex(newIndex);
    }
  };

  return (
    <Accordion fluid styled exclusive={false}>
      {contents.map((content, index) => (
        <AccordionContentComponent
          key={`accordion-item-${index}`}
          index={index}
          activeIndex={activeIndex}
          handleClick={handleClick}
          content={content}
          contentClassName={contentClassName}
        />
      ))}
    </Accordion>
  );
};

export default AccordionComponent;
